import { create } from "zustand";

type IState = {
  windyMap: any;
  mapStore: any;
  layer: any;
  overlay: string; // add this
};
type IAction = {
  setWindyMap: (map: any) => void;
  setMapStore: (store: any) => void;
  setLayer: (layer: any) => void;
  setOverlay: (key: string) => void; // add setter
};

export const useWindyMapStore = create<IState & IAction>((set) => ({
  windyMap: null,
  mapStore: null,
  layer: undefined,
  overlay: "wind", // default overlay
  setWindyMap: (windyMap) => set({ windyMap }),
  setMapStore: (mapStore) => set({ mapStore }),
  setLayer: (layer) => set({ layer }),
  setOverlay: (overlay) => set({ overlay }), // reactive setter
}));
